<!--
  name : 김혜진
  desc : header-멤버용
  date : 2020-12-08
-->
<template>
  <v-toolbar no-gutters elevation="0" align="center" id="top_bar">
    <v-toolbar-title class="top_bar_logo-voucher" @click="goMain"
      >로고</v-toolbar-title
    >
    <v-row no-gutters class="top_bar_pc justfy-end align-center">
      <v-btn class="btn_top_bar btnTBhome" @click="goMain"
        ><span class="icon"></span>서비스 소개</v-btn
      >
    </v-row>
  </v-toolbar>
</template>
<script>
export default {
  name: "voucher-header",
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    goMain() {
      this.$router.push({ name: "main" });
    }
  }
};
</script>
<style>
.voucher-header_nameFix {
  font-size: 0.7rem;
  color: #fff !important;
}
</style>
